<template>
  <div class="pending-order-component">
    <div v-if="pending">
      <h2>Your order is pending, please wait...</h2>

      <span class="spinner-border" role="status" aria-hidden="true"></span>
      <span class="sr-only">Loading...</span>
    </div>

    <div v-else>
      <h2>We haven't been able to check your order yet</h2>
      <p>You can try and refresh this page or contact us.</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pending: true,
      checkedCount: 0,
      checkOrderInterval: null,
    };
  },

  props: {
    'orderId': {
      type: Number,
      required: true,
    },
  },

  watch: {
    //
  },

  created() {
    this.checkOrderInterval = setInterval(() => {
      this.checkOrder();
    }, 500);
  },

  methods: {
    checkOrder() {
      this.checkedCount += 1;

      axios.get(window.api_url + '/customiser/check_order/' + this.orderId)
        .then(res => {
          if (res.data && res.data.success && res.data.paid && res.data.success_url) {
            window.location = res.data.success_url;
          }
        })
        .catch(err => {
          //
        })
        .finally(() => {
          //
        });

      if (this.checkedCount >= 20) {
        this.pending = false;
        clearInterval(this.checkOrderInterval);
      }
    },
  },
};
</script>
